// extracted by mini-css-extract-plugin
export var equalColumn = "_hc-0";